import { render } from "./ToggleSwitchButton.vue?vue&type=template&id=0afd0e20&scoped=true&ts=true"
import script from "./ToggleSwitchButton.ts?vue&type=script&lang=ts"
export * from "./ToggleSwitchButton.ts?vue&type=script&lang=ts"

import "./ToggleSwitchButton.scss?vue&type=style&index=0&id=0afd0e20&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0afd0e20"]])

export default __exports__